export interface LanguageState {
  currentLang: string;
}

export const initialLanguageState: LanguageState = {
  currentLang: 'ar',
};
